// Web-Audio-basierte Alarm-/Signaltöne (keine Audiodateien nötig)
let ctx = null;
let alarmTimer = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

// Einmaligen Piepton erzeugen
export function beep(freq = 880, duration = 0.18, gain = 0.25, type = "sine") {
  const audio = getCtx();
  const osc = audio.createOscillator();
  const g = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(g);
  g.connect(audio.destination);
  g.gain.setValueAtTime(gain, audio.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, audio.currentTime + duration);
  osc.start();
  osc.stop(audio.currentTime + duration);
}

// Wiederholender Alarm bis stopAlarm() aufgerufen wird
export function startAlarm() {
  stopAlarm();
  const ring = () => {
    beep(880, 0.15, 0.3);
    setTimeout(() => beep(1174, 0.15, 0.3), 180);
  };
  ring();
  alarmTimer = setInterval(ring, 850);
}

export function stopAlarm() {
  if (alarmTimer) {
    clearInterval(alarmTimer);
    alarmTimer = null;
  }
}

// Freundlicher Dreiklang, wenn der Timer endet
export function playChime() {
  beep(660, 0.22, 0.28);
  setTimeout(() => beep(880, 0.22, 0.28), 230);
  setTimeout(() => beep(1174, 0.32, 0.28), 470);
}

// AudioContext bei erster Nutzerinteraktion entsperren (Browser-Policy)
export function unlockAudio() {
  try {
    getCtx();
  } catch (_) {}
}

// --- Browser-Benachrichtigungen ---
export async function ensureNotifyPermission() {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const res = await Notification.requestPermission();
  return res === "granted";
}

export function notify(title, body) {
  if ("Notification" in window && Notification.permission === "granted") {
    try {
      new Notification(title, { body });
    } catch (_) {}
  }
}
